module.exports = __webpack_public_path__ + "static/media/muscle_front_4.57830733.png";